import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStore, faScroll } from '@fortawesome/free-solid-svg-icons'

// The home screen's bottom bar: the Shop (not built yet: greyed out, not
// tappable), the Hive, which counts what waits to be placed on it, and War
// history, which counts the wars waiting on you.
function HiveIcon() {
    const hex = (x, y) => [0, 60, 120, 180, 240, 300]
        .map(a => `${(x + 4.6 * Math.cos(a * Math.PI / 180)).toFixed(2)},${(y + 4.6 * Math.sin(a * Math.PI / 180)).toFixed(2)}`).join(' ')
    return (
        <svg className="pt-nav__icon" viewBox="0 0 20 20" aria-hidden="true">
            <polygon points={hex(5.4, 10)} />
            <polygon points={hex(12.3, 6)} />
            <polygon points={hex(12.3, 14)} />
        </svg>
    )
}

export default function AppNav({ onHive, onHistory, toPlace = 0, yourMove = 0 }) {
    return (
        <nav className="pt-nav" aria-label="Main">
            <button className="pt-nav__item" disabled aria-disabled="true">
                <FontAwesomeIcon icon={faStore} className="pt-nav__icon" />
                <span>Shop</span>
            </button>
            <button className="pt-nav__item" onClick={onHive}>
                <span className="pt-nav__iconwrap">
                    <HiveIcon />
                    {toPlace > 0 && <span className="pt-nav__badge" aria-label={`${toPlace} to place`}>{toPlace}</span>}
                </span>
                <span>Hive</span>
            </button>
            <button className="pt-nav__item" onClick={onHistory}>
                <span className="pt-nav__iconwrap">
                    <FontAwesomeIcon icon={faScroll} className="pt-nav__icon" />
                    {yourMove > 0 && <span className="pt-nav__badge" aria-label={`${yourMove} waiting on you`}>{yourMove}</span>}
                </span>
                <span>War history</span>
            </button>
        </nav>
    )
}
